module.exports = __webpack_public_path__ + "img/735-ef3b18.png";